var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fbk-page',[_c('student-book-list'),_c('br'),_c('supervisor-book-list'),_c('br'),_c('instructor-book-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }